import { BehaviorSubject } from "rxjs";
import { Injectable, OnDestroy } from "@angular/core";
import {ThirdpartyDocumentsAemItem} from "@app/models/aem.model";

@Injectable({ providedIn: 'root' })
export class AemContentService implements OnDestroy{
  private dataSubject = new BehaviorSubject<ThirdpartyDocumentsAemItem | null>(null);
  data$ = this.dataSubject.asObservable();

  sendData(content: ThirdpartyDocumentsAemItem) {
    this.dataSubject.next(content);
  }
  ngOnDestroy() {
    this.dataSubject.unsubscribe();
  }
}
